import React, { useState } from 'react';
import slide1icon from "../images/version3/resize/slider_1_icon.png";
import slide2icon from "../images/version3/resize/slider_2_icon.png";
import slide3icon from "../images/version3/resize/slider_3_icon.png";
import slide4icon from "../images/version3/resize/slider_4_icon.png";
import slide5img1 from "../images/learn-about-us-slider/technology/1.png";
import slide6img1 from "../images/learn-about-us-slider/perspectives/1.png";



import Modal from '../components/Modal';
import Slider from '../components/Slider';
import { getSlider } from './SliderFiles';
// import ImageSlider from './ImageSlider';
import SliderCarousel from "../GHT/components/ImageCarousel"


const sliderData = [
    { file: slide1icon, uniqueId: "1", extType: "image" },
    { file: slide2icon, uniqueId: "2", extType: "image" },
    { file: slide3icon, uniqueId: "3", extType: "image" },
    { file: slide4icon, uniqueId: "4", extType: "image" },
    { file: slide5img1, uniqueId: "5", extType: "image" },
    { file: slide6img1, uniqueId: "6", extType: "image" },
    { file: slide5img1, uniqueId: "7", extType: "video", videoUrl: "https://tv.teqbahn.com/teqitTv-api/files?processType=assets&fileName=9998c365-ec88-4742-ace7-88cfa3cb3433.mp4" },
    { file: slide6img1, uniqueId: "8", extType: "video", videoUrl: "https://tv.teqbahn.com/teqitTv-api/files?processType=assets&fileName=1fec78a5-9eac-4a4d-9121-0b5b1f871475.mp4" },
]
export default function LearnAboutUs() {
    let [sliderStopped, setSliderStopped] = useState(false);
    let [active, setActive] = useState("");
    let activeData = {};
    let findindex = sliderData.findIndex((fe) => fe.uniqueId === active)
    if (findindex !== -1) {
        activeData = sliderData[findindex]
    }

    function viewModalData() {
        let { extType, videoUrl, file } = activeData
        let returnText = ""
        switch (extType) {
            case "video":
                returnText = <div className="embed-responsive" style={{ height: "80vh" }}>
                    <video className="embed-responsive-item" controls poster={file}>
                        <source src={videoUrl} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                </div>
                break;
            case "image":
                returnText = <Slider slider={getSlider(active, "80vh")} />
                break;

            default:
                returnText = ""
                break;
        }
        return returnText

    }


    return <React.Fragment>

        <div className='learn-about-us social-impact'>
            {/* <ImageSlider sliderView={4} sliderOnclick={(clickid) => {
                setActive(clickid)
                setSliderStopped(true)
            }} sliderData={sliderData}
                sliderStopped={sliderStopped}
            /> */}
            <SliderCarousel images={sliderData} sliderOnclick={(id) => {
                setActive(id)
            }} />
        </div>
        {
            active && <Modal
                visible={active ? true : false}
                closeModal={() => {
                    setActive("")
                    setSliderStopped(false)
                }}
                heading={""}
                size={"modal-xl"}
                body={<React.Fragment>
                    {viewModalData()}
                </React.Fragment>
                }
                footer={<button className='btn btn-sm btn-primary' style={{ cursor: "pointer" }} onClick={() => {
                    setActive("")
                    setSliderStopped(false)
                }}>Close</button>}
            />
        }
    </React.Fragment>;
}
